export const faqList = [
  {
    question: '什么是黄色网站？',
    answer: '黄色网站是指以传播淫秽色情内容为主要目的的网站，包括但不限于色情图片、视频、小说、直播等内容。这些网站通常以盈利为目的，通过广告、会员付费等方式获取收益，对浏览者的身心健康造成严重危害。根据《中华人民共和国刑法》和《治安管理处罚法》，制作、复制、出版、贩卖、传播淫秽物品均属违法行为。',
  },
  {
    question: '浏览黄网会带来哪些危害？',
    answer: '浏览黄网会带来多方面的危害：心理层面，容易导致性观念扭曲、成瘾依赖，影响正常的人际交往和婚恋观；生理层面，长期沉溺可能导致注意力不集中、记忆力下降、睡眠质量降低；社会层面，可能影响学业和职业发展，严重者甚至走向违法犯罪道路；网络安全层面，黄网常携带恶意软件和病毒，危及个人隐私和财产安全。',
  },
  {
    question: '如何识别一个网站是否是黄网？',
    answer: '识别黄网可以从以下几个方面入手：一是观察域名，黄网常使用乱码、拼音缩写或模仿知名网站域名；二是检查页面内容，是否包含大量低俗暴露的图片或视频；三是注意弹窗广告，黄网通常弹出大量色情广告；四是查看网站备案信息，正规网站底部应有ICP备案号；五是使用安全软件，可自动拦截已知的黄网。',
  },
  {
    question: '访问黄网是否违法？',
    answer: '在我国，单纯浏览黄色网站一般不构成刑事犯罪，但属于违反治安管理的行为。然而，如果涉及下载、存储、传播淫秽色情内容，则可能触犯《刑法》第三百六十三条和第三百六十四条，面临刑事处罚。特别是传播淫秽物品牟利的行为，量刑较重。建议广大网民自觉抵制，远离黄网。',
  },
  {
    question: '如何有效防范孩子接触黄网？',
    answer: '家长可以从以下方面保护孩子：安装家长控制软件和网络过滤工具，设置安全浏览模式；与孩子建立良好的沟通，进行适龄的性教育和网络安全教育；将电脑放置在家庭公共区域，限制孩子独自在封闭空间上网；定期检查浏览记录，关注孩子的网络行为；引导孩子培养健康的兴趣爱好，减少沉溺网络的时间。',
  },
  {
    question: '发现黄网应该向谁举报？',
    answer: '发现黄网后，可以通过以下渠道举报：拨打12321网络不良与垃圾信息举报受理中心热线；登录中国互联网违法和不良信息举报中心（www.12377.cn）进行在线举报；向当地公安机关网安部门举报；通过各大安全软件（如360、腾讯管家）的举报功能提交。举报时应尽可能提供网站域名、截图等证据材料。',
  },
  {
    question: '不小心点开黄网后应该怎么做？',
    answer: '如果不小心点开了黄网，首先立即关闭该页面，不要因为好奇而继续浏览；其次，清除浏览器缓存和历史记录；然后，使用杀毒软件进行全盘扫描，检查是否被植入了恶意程序；最后，如果发现个人信息可能泄露，应及时修改相关账号密码。如果频繁遭遇此类网站弹窗，建议安装广告拦截插件。',
  },
  {
    question: '网络色情对青少年有哪些特殊危害？',
    answer: '网络色情对青少年的危害尤为严重：青少年正处于身心发展的关键期，接触色情内容会导致性心理早熟和扭曲，影响正常的性观念形成；容易产生焦虑、抑郁等心理问题；可能导致模仿色情内容中的危险行为；严重影响学业，分散注意力，降低学习成绩；甚至可能诱导青少年走向性犯罪的道路。保护青少年远离网络色情是全社会的共同责任。',
  },
];